import { Autocomplete } from '@coolblue-development/freddy';
import { RoutingProfile } from '../../../../models/RoutingProfiles';

interface RoutingProfileSelectorProps {
  selectedRoutingProfile: string;
  onRoutingProfileChange: (value: string) => void;
  routingProfiles: RoutingProfile[];
  hasError: boolean;
  isDisabled: boolean;
  errorMessage?: string;
}

const AUTOCOMPLETE_TRANSLATIONS = {
  labelChipsCollapsed: '',
  labelLoading: 'Loading...',
  labelNoOptions: 'No routing profiles found',
  labelSelectAll: 'Select all',
  ariaLabelOpenDropdown: 'Open dropdown',
  ariaLabelCloseDropdown: 'Close dropdown',
  ariaLabelRemoveChip: 'Remove',
  ariaLabelRemoveAllChips: 'Remove all'
};

export const RoutingProfileSelector = ({
  selectedRoutingProfile,
  onRoutingProfileChange,
  routingProfiles,
  hasError,
  isDisabled,
  errorMessage
}: RoutingProfileSelectorProps): JSX.Element => {
  const selectedValue = routingProfiles.find(profile => profile.id === selectedRoutingProfile);

  return (
    <Autocomplete<RoutingProfile>
      options={routingProfiles}
      value={selectedValue ?? null}
      onChange={value => onRoutingProfileChange(value ? value.id : '')}
      getOptionLabel={(option: RoutingProfile) => option.name}
      getOptionKey={(option: RoutingProfile) => option.id}
      placeholder="Select or search a routing profile"
      disabled={isDisabled}
      validation={hasError ? 'error' : undefined}
      helperText={hasError ? errorMessage : undefined}
      translations={AUTOCOMPLETE_TRANSLATIONS}
      sx={{ marginTop: '16px', width: '100%' }}
    />
  );
};
